import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ThemeService, AuthService } from '../../providers/index';

@Component({
  selector: 'page-voltio-landing',
  templateUrl: 'voltio-landing.html'
})
export class VoltioLandingPage {

  projectName: string;
  projectTitle: string;
  iconLocation: string;


  constructor(public navCtrl: NavController, public navParams: NavParams, private _theme: ThemeService, private _auth: AuthService) {

    this.projectTitle = this._theme.getTitle();
    this.projectName = this._theme.getNameOfTheme();
    this.iconLocation = this._theme.getIconLocation();

    console.log('Landing page for following theme: ' + this.projectTitle
      + ', Name: ' + this.projectName
      + ', Slogan: ' + this._theme.getSlogan()
      + ', Title: ' + this._theme.getTitle());

  }

  // signInWithLocalCredentials(): void {
  //   console.log('redirect to login page');
  //   this.navCtrl()
  // }

  signInWithFacebook(): void {
    console.log('authenticating with facebook');
    this._auth.signInWithFacebook()
      .then(() => this.onSignInSuccess());
  }


  signInWithGoogle(): void {
    console.log('authenticating with google');
    this._auth.signInWithGoogle()
      .then(() => this.onSignInSuccess());
  }

  private onSignInSuccess(): void {
    console.log("Display name ",this._auth.displayName());
    console.log("Display email ",this._auth.displayEmail());
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VoltioLandingPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/voltio-landing/voltio-landing.ts